import { render, staticRenderFns } from "./_payroll.vue?vue&type=template&id=70379e11&scoped=true&"
import script from "./_payroll.vue?vue&type=script&lang=js&"
export * from "./_payroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70379e11",
  null
  
)

export default component.exports